import(/* webpackMode: "eager" */ "/codebuild/output/src2444236237/src/downfor-webapp/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2444236237/src/downfor-webapp/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2444236237/src/downfor-webapp/src/components/blog/post-body/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2444236237/src/downfor-webapp/src/components/blog/post-modal/index.jsx");
